import { Brush, HandHeart, Gem, Users } from "lucide-react";

const POINTS = [
  { icon: Brush, title: "100% Hand-Painted", desc: "No prints. No machines. No shortcuts. Only a brush and four decades of skill." },
  { icon: Gem, title: "Heirloom Quality", desc: "Pure silks, breathable fabrics, and pigments chosen to age beautifully over generations." },
  { icon: Users, title: "Direct With the Artist", desc: "No middlemen, no studios, no resellers. You commission the artist, directly." },
  { icon: HandHeart, title: "Only for You", desc: "Every ARVI piece is one-of-one. No repeats, no duplicates — ever." },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-section"
      className="bg-parchment py-24 md:py-32 border-y border-[hsl(var(--gold)/0.3)]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 reveal">
          <p className="text-overline text-gold mb-5">The ARVI Difference</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
            Not mass-produced.
            <br />
            <span className="italic">Meaningfully made.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[hsl(var(--gold)/0.35)]">
          {POINTS.map((p, i) => (
            <div
              key={i}
              data-testid={`why-point-${i}`}
              className="bg-parchment p-10 md:p-12 reveal"
            >
              <p.icon className="h-6 w-6 text-gold" strokeWidth={1.4} />
              <h3 className="mt-8 font-display text-xl md:text-[22px] text-maroon leading-tight">
                {p.title}
              </h3>
              <p className="mt-4 text-[14px] text-maroon/70 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
